var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{key:`${_vm.id}__catalog_list`},[_vm._l((_vm.catalogList),function(catalog,index){return [_c(_setup.CatalogItem,{key:`${index}__${catalog.id}`,attrs:{"catalog":catalog,"index":index}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }